import React, { Component } from 'react';
import { connect } from 'react-redux';
import './login.css';
import { withRouter } from 'react-router-dom';
import {userActions} from '../acciones/userActions';
import ValidacionCampo from 'react-comun-seps/lib/components/ValidacionCampo';
import { Link } from 'react-router-dom';
import { userService } from '../servicios/userService';
import MensajeAlertaInline from 'react-comun-seps/lib/components/MensajeAlertaInline';
import {Growl} from 'primereact/components/growl/Growl';


var I18n = require('react-redux-i18n').I18n;

class claveNuevaComponent extends Component{
    constructor(props) {
        super(props);
        // reset login status
        this.props.dispatch(userActions.logout());

        this.state = {
            username: '',
            newpassword: '',
            repassword:'',
            submitted: false,
            ticket2: '',
            procesado: '',
            home: ''
        };
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.showResponse = this.showResponse.bind(this);
        this.showInfo = this.showInfo.bind(this);
    }
    showResponse() {
        this.growl.show({sticky: true, severity: 'info', summary: 'Success', detail: 'User Responded'});
    }

    
    showInfo() {
        this.growl.show({sticky: true, severity: 'info', summary: 'Valides de la solicitud', detail: 'Vigencia de la solicitud a expirado, genere nuevamente otra solicitud.'});
    }

    componentDidMount() {
        document.body.classList.add('login-body');
        const { dispatch } = this.props;
        this.setState({procesado: false});
        this.setState({ home: false});
        const URL = window.location.search;
        const partes = URL.split("?tk=");
        const ticket = partes[1]; 
        this.setState({ticket2: ticket});
        userService.validaTicket(ticket)
        .then(
            respuesta => {
                if(!respuesta){
                    this.setState({muestraform: true});
                }else{
                    this.setState({muestraform: false});
                }})
    }

    componentWillUnmount() {
        document.body.classList.remove('login-body');
    }

    onChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }
    onSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });
        this.setState({ permiso: true });
        this.setState({ procesado: true});
        const { usuario, contrasenia, repassword, ticket2 } = this.state;
        const { dispatch } = this.props;
        if (usuario && contrasenia && repassword) {
            if(contrasenia != repassword) {
            } else {
                dispatch(userActions.confirmaClaveNueva(usuario,contrasenia,ticket2));
                this.setState({ muestraform: false});
                this.setState({ home: true});
            }
        }
    }
    render(){
        const { usuario, contrasenia, repassword ,submitted, muestraform, procesado, home } = this.state;
        const { alert } = this.props;
        return (
        <div>
            <div className="text-center logo-login">
                <img src="/assets/images/login/login.png" />
            </div>
            <div className="card login-panel ui-fluid">
                <div className="login-panel-content">
                {submitted && alert && 
                        <MensajeAlertaInline tipoMensaje={alert.tipoMensaje} detalle={alert.detalle}/>
                }
                    <div className="ui-g">
                    { !home && <div>
                        <div className="ui-g-3 text-left">
                            <img src="/assets/images/login/icon-login.svg" />
                        </div>
                        <div className="ui-g-9 text-right">
                            <h2 className="welcome-text">Cambio de contraseña</h2>
                            <Growl ref={(el) => this.growl = el}></Growl>                
                        </div>
                        </div>
                    }
                        { muestraform && <form name="form" onSubmit={this.onSubmit}>
                            <div className={'ui-g-12 text-left'}>
                                <label className="login-label" htmlFor="usuario">{I18n.t('app.usuario')}</label>
                                <div className="login-input">
                                    <input type="text" className="ui-inputtext ui-widget ui-state-default ui-corner-all" name="usuario" value={usuario} onChange={this.onChange} />
                                        {submitted && !usuario &&
                                            <ValidacionCampo mensaje = {I18n.t('formulario.campo_obligatorio')} />
                                        }
                                </div>
                            </div>
                            <div className={'ui-g-12 text-left'}>
                                <label className="login-label">{I18n.t('app.new_password')}</label>
                                <div className="login-input">
                                    <input type="password" className="ui-inputtext ui-widger ui-state-default ui-corner-all" name="contrasenia" onChange={this.onChange} />
                                    {submitted && !contrasenia &&
                                            <ValidacionCampo mensaje = {I18n.t('formulario.campo_obligatorio')} />
                                        }
                                </div> 
                            </div>
                            <div className={'ui-g-12 text-left'}>
                                <label className="login-label">{I18n.t('app.re_password')}</label>
                                <div className="login-input">
                                    <input type="password" className="ui-inputtext ui-widger ui-state-default ui-corner-all" name="repassword" onChange={this.onChange} />
                                    {submitted && !repassword &&
                                            <ValidacionCampo mensaje = {I18n.t('formulario.campo_obligatorio')} />
                                        }
                                </div> 
                            </div>
                            <div className="ui-g-12 ui-md-6 button-pane">
                                    <button className="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" role="button" disabled= {procesado}>
                                        <span className="ui-button-text ui-c">Confirmar</span>
                                    </button>
                            </div>
                            <div className="ui-g-12 ui-md-6 link-pane">
                                <Link to="/">Cancelar</Link>
                            </div>
                            
                            </form> 
                        }
                        {home && <div className="ui-g-12 ui-md-6 link-pane">
                                <Link to="/">Ir al Inicio</Link>
                            </div>}
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

function mapStateToProps(state) {
    const { alert, permiso, muestraform } = state;
    return {
        alert, permiso, muestraform
    };
}
const connectedclaveNuevaComponent = withRouter(connect(mapStateToProps)(claveNuevaComponent));
export { connectedclaveNuevaComponent as claveNuevaComponent }; 